import React, {useState} from "react";
import CustomTh from "../../../components/table/CustomTh";
import CustomTd from "../../../components/table/CustomTd";
import { ReactComponent as UnlinkIcon } from '../../../assets/images/link-slash-solid.svg';
import { ReactComponent as LinkIcon } from '../../../assets/images/link-solid.svg';
import TableFunction from "../../../components/table/TableFunction";
import DropDownMenuItem from "../../../components/DropDown/DropDownMenuItem";
import DropDownMenuProfile from "../../../components/DropDown/DropDownMenuProfile";
import { SimpleSearch} from "../../../reduxToolkit/Search/SearchApi";
import {useDispatch, useSelector} from "react-redux";
import {TABLES} from "../../../Apis/Tables";
import {
    SEARCH_MODEL
} from "../../../components/table/Model/TableModel";
import {EMPTY_VALUES, getDateFormat} from "../../../Apis/functions";
import {permissionObj} from "../../../Helpers/permission";
import {DetailsIconsOptions} from "../../../components/buttons/IconButtons";

const CardsTableApp = ({
    selectedList,
    setSelectedList,
    onAssignUnassign,
    onPreview,
    onDisassignTemplate,
    setBodyForExport,

    modified,
    setModified,
    setIsAllChecked,
    searchElement,
    results,
    setResults
}) =>
{
    const dispatch = useDispatch();
    const [tableId, setTableId] = useState("tbl_cta_cards");
    const [searchId, setSearchId] = useState("txt_cta_cards");
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const option = `${TABLES.CARD}`;
    const deletePermission = (DEV || permission?.includes(permissionObj?.WEB_CARD_DELETE) || permission?.includes(permissionObj?.WEB_CARD_MANAGE_USERS) || permission?.includes(permissionObj?.WEB_CARD_MANAGE_TEMPLATES));
    const leftPosition = deletePermission ? 50 : 0;

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes="first_head">{t('number')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('user')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('facility_code')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('format')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('created_at')}</CustomTh>,
        ];
    }

    const getTbody = () => {
        if(!results || results?.content?.length === 0) return {
            body: [],
            data: []
        };

        let body =  results?.content?.map((item, index) => {
            return (
                <>
                    <CustomTd tableId={tableId} fixed={true} left={leftPosition} classes={"first-column"}>
                        {item?.number}
                    </CustomTd>
                    <CustomTd tableId={tableId} >{item?.fullName || item?.userFullName}</CustomTd>
                    <CustomTd tableId={tableId} >{item?.facilityCode}</CustomTd>
                    <CustomTd tableId={tableId}>{item?.format || item?.cardTypeName}</CustomTd>
                    <CustomTd tableId={tableId}>{getDateFormat(item?.createdAt) || EMPTY_VALUES.DEFAULT}</CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: results?.content
        }
    };

    const getActionsButtons = (item, index) => {
        return <>
            {(DEV || permission?.includes(permissionObj?.WEB_CARD_MANAGE_USERS) || item.raw) ?
                <DropDownMenuProfile
                    openMenu={openMenu}
                    handleMenuToggle={handleMenuToggle}
                    menuId={`menu-${item.id}`}
                >
                    {(DEV || permission?.includes(permissionObj?.WEB_CARD_MANAGE_USERS)) &&
                    <DropDownMenuItem
                        id={"btn_cta_un_assign_"+ item.id}
                        index={index}
                        handleClose={handleClose}
                        name={ item?.userId !== null
                            ? t('disassign_employee').toUpperCase()
                            : t('assign_employee').toUpperCase()}
                        icon= {item.userId !== null ? (
                            <UnlinkIcon/>
                        ) : (
                            <LinkIcon/>
                        )}
                        click={() => onAssignUnassign(item)}
                    />
                    }

                    {(DEV || permission?.includes(permissionObj?.WEB_CARD_MANAGE_TEMPLATES)) && item.raw &&
                    <DropDownMenuItem
                        id={"btn_cta_disassign_template_"+ item.id}
                        index={index}
                        handleClose={handleClose}
                        name={t('disassign_template')}
                        icon= {<UnlinkIcon/>}
                        click={() =>onDisassignTemplate(item)}
                    />
                    }

                    {item.raw && (
                        <DropDownMenuItem
                            id={"btn_cta_preview_"+ item.id}
                            index={index}
                            handleClose={handleClose}
                            name={t('preview').toUpperCase()}
                            icon= {<DetailsIconsOptions/>}
                            click={() => onPreview(item.id)}
                        />)}
                </DropDownMenuProfile>
                :
                EMPTY_VALUES.DEFAULT
            }
        </>;
    }

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({page, size:rowsPerPage, model:option, key:searchElement })
        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(
            ({payload: {data: { data, success }}}) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    }


    const {t, thead, tbody, handleCheckboxChange,
        openMenu, handleMenuToggle, handleClose, handleDeleteAll,
        pagination, rowsPerPage} = TableFunction({
        selectedList,
        setSelectedList:setSelectedList,
        data:results,
        getThead,
        getTbody,
        labelRowsPerPage:'cards_per_page',
        setIsAllChecked,
        searchElement,//New
        getData,//New
        modified,//New
        setModified,//New
    });

    return {
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage,
        contractorId,
        supplierId,
        deletePermission
    };

}
export default CardsTableApp;
